<template>
  <div v-if="orderSelectYn == true">
    <div class="dimed wrap">
      <div class="layer">
        <div class="layer__header">
          <div class="lyr-title">{{ $t('Modal.OrderSelect.msg1') }}</div>
          <div class="ft-point">
            {{ $t('Modal.OrderSelect.msg2') }}
          </div>
          <div class="lyr-txt">{{ $t('Modal.OrderSelect.msg3') }}</div>
        </div>
        <div class="layer__body">
          <div class="btn-inline">
            <button
              class="btn-intro btn-intro--half btn--color btn-anim"
              @mouseup="
                setOrder('S');
                $store.dispatch('setOrderType', 1);
                $logInfo('Order Click Eat In');
              "
            >
              <span class="txt">{{ $t('Modal.OrderSelect.msg4') }}</span>
              <i class="ico-go"></i>
            </button>
            <button
              class="btn-intro btn-intro--half btn--color btn-anim"
              @mouseup="
                setOrder('T');
                $store.dispatch('setOrderType', 2);
                $logInfo('Order Click Takeout');
              "
            >
              <span class="txt">{{ $t('Modal.OrderSelect.msg5') }}</span>
              <i class="ico-go"></i>
            </button>
          </div>
        </div>
        <div class="layer__button">
          <button
            class="btn btn--line btn--xlg btn-anim"
            @mouseup="
              $emit('closeOrderSelect');
              $logInfo(`Order Select Close`);
            "
          >
            {{ $t('Modal.OrderSelect.msg6') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'orderSelect',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },

  props: {
    orderSelectYn: Boolean,
  },
  methods: {
    setOrder(type) {
      this.$emit('setOrder', type);
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    orderSelectYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00105', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
